import { useEffect } from "react";
import classnames from "classnames";

// brands
import img_amazon from "./img/amazon.png";
import img_apple from "./img/apple.png";
import img_brex from "./img/brex.png";
import img_cage from "./img/cage.png";
import img_eb from "./img/eb.png";
import img_google from "./img/google.png";
import img_natgeo from "./img/natgeo.png";
import img_nfl from "./img/nfl.png";
import img_nvite from "./img/nvite.png";
import img_quora from "./img/quora.png";
import img_samsung from "./img/samsung.png";
import img_svmk from "./img/svmk.png";
import img_twitch from "./img/twitch.png";
import img_zillow from "./img/zillow.png";

// work
import img_work0 from "./img/work0.png";
import img_work2 from "./img/work2.png";
import img_work3 from "./img/work3.png";
import img_work4 from "./img/work4.png";
import img_work6 from "./img/work6.png";
import img_workcard from "./img/work-card.png";
import img_work9 from "./img/work9.png";
import img_workenergy from "./img/work-energy.png";
import img_workmap from "./img/work-map.png";
import img_gatherchat from "./img/gather-chat.png";
import img_card from "./img/card.png";
import img_cage2 from "./img/cage.jpg";
import img_sync from "./img/sync.png";
import img_cmd from "./img/cmd.jpg";
import img_flow from "./img/flow.png";

//  ui
import cursor from "./img/cursor.png";
import img_blockT1 from "./img/block-t-1.png";
import img_blockT2 from "./img/block-t-2.png";
import img_blockT3 from "./img/block-t-3.png";
import img_blockT4 from "./img/block-t-4.png";
import img_blockB1 from "./img/block-b-1.png";
import img_blockB2 from "./img/block-b-2.png";
import img_blockB3 from "./img/block-b-3.png";
import img_blockB4 from "./img/block-b-4.png";

function calcActivity() {
  const date = new Date();

  const weekday = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    timeZone: "America/Chicago",
  }).format(date);

  const time = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    timeZone: "America/Chicago",
  })
    .format(date)
    .split(" ");

  const online = (
    <p className="-mt-1 font-medium text-lime-500 text-sm block text-center md:text-right font-bold flex items-center justify-center md:justify-end">
      Currently at my desk
      <i className="material-icons text-lime-500 ml-2 text-lg">devices</i>
    </p>
  );

  const offline = (
    <p className="-mt-1 text-red-500 text-sm block text-center md:text-right font-bold flex items-center justify-center md:justify-end">
      Away from my desk
      <i className="material-icons text-red-500 ml-2 text-lg">mobile_off</i>
    </p>
  );

  const hour = time[0];
  console.log(hour);
  const timing = time[1];
  const workdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  const isWorkDay = workdays.includes(weekday);
  const isWorkingHours =
    (hour >= 9 && timing === "AM") ||
    ((hour < 5 || hour >= 12) && timing === "PM");

  let act = online;
  if (!isWorkDay) {
    act = offline;
  } else if (isWorkDay && isWorkingHours) {
    act = online;
  } else if (isWorkDay && !isWorkingHours) {
    act = offline;
  }

  return act;
}

function Desk() {
  return (
    <div className="text-center md:text-right">
      <p className="flex items-center justify-center md:justify-end whitespace-nowrap leading-tight">
        <span className="font-bold text-white text-base md:text-base">
          Prosper, TX
        </span>
        <i className="material-icons block text-white ml-2 text-lg md:text-xl leading-tight">
          public
        </i>{" "}
      </p>

      {calcActivity()}
    </div>
  );
}

function HUD() {
  return (
    <div className="flex justify-between pb-8 pt-4 px-2 md:p-4 items-center">
      <img
        src="https://pbs.twimg.com/profile_images/1965794361901285376/YVJd46jU_400x400.jpg"
        className="rounded-3xl w-20 md:w-20 mr-2 shadow"
        alt="Mike Dick's avatar"
        style={{ width: "72px" }}
      />
      <div className="bg-dark rounded-3xl py-3 pr-8 pl-10 w-full md:w-auto shadow-lg border-2 border-main">
        {Desk()}
      </div>
    </div>
  );
}

// eslint-disable-next-line no-unused-vars
function _Rule() {
  return (
    <div
      className="rule mx-auto block py-16 md:py-16"
      style={{
        maxWidth: "1000px",
        height: "2px",
      }}
    ></div>
  );
}

function Badge({ color = "midnight", children }) {
  const classes = classnames({
    "text-sm md:text-base mt-3 md:mt-8 md:px-5 px-2 py-1 md:py-2 inline-flex items-center justify-center font-bold rounded-3xl": true,
    "bg-dark2 text-gray-400": color === "midnight",
    "hover:bg-lime-500 text-black bg-white": color === "green",
  });
  return <div className={classes}>{children}</div>;
}

function Section({ children }) {
  return (
    <div className="p-2 md:p-16 pb-0 md:pb-0 w-full">
      <div className="bg-check rounded-3xl">
      <div style={{ maxWidth: "1250px", minHeight: "90vh"}} className="mx-auto px-8 md:px-24 flex flex-col justify-center py-16 md:py-32">{children}</div>
    </div>
    </div>
  );
}

function Title({ size, children }) {
  const classes = classnames({
    "text-white font-bold mb-4 leading-none": true,
    "text-2xl md:text-3xl": size === "sm",
    "text-5xl md:text-8xl": size !== "sm",
  });
  return <h3 className={classes}>{children}</h3>;
}

function Para({ children }) {
  return (
    <p className="text-gray-400 text-base md:text-2xl font-normal">{children}</p>
  );
}

function Block({ row = 1, w = "4x", color, pattern = "none", children }) {
  const classes = classnames({
    "flex-grow mt-2 pl-2 items-stretch self-stretch": true,
    "w-full md:w-1/4": w === "4x",
    "w-full md:w-1/3": w === "3x",
  });

  const classesinner = classnames({
    "h-full flex justify-center items-center md:transform duration-100 text-base transition-all rounded-3xl shadow": true,
    "bg-dark border-2 border-main": (row === 1 || row === "1") && color !== "none",
    "bg-dark2 border-2 border-main2": (row === 2 || row === "2") && color !== "none",
    "bg-dark3 border-2 border-main3": (row === 3 || row === "3") && color !== "none",
    "bg-top":
      pattern === img_blockT1 ||
      pattern === img_blockT2 ||
      pattern === img_blockT3 ||
      pattern === img_blockT4,
    "bg-bottom":
      pattern === img_blockB1 ||
      pattern === img_blockB2 ||
      pattern === img_blockB3 ||
      pattern === img_blockB4,
  });

  return (
    <div className={classes}>
      <div className={classesinner}>{children}</div>
    </div>
  );
}

function CTA() {
  return (
    <div>
      <p className="md:flex items-center">
        <i className="block md:inline material-icons text-lime-500 mr-3 text-3xl pt-2 mb-2 md:mb-0">
          event_available
        </i>{" "}
        <span className="text-xl text-lime-100">
          Book a freelance project {"->"}{" "}
          <a
            className="txtlink underline text-lime-500"
            href="mailto:mike@m1k3.net?subject=👋 Freelance opportunity&body=Hey Mike, I'd love to chat about _______________"
          >
            <span>email me</span>
          </a>
        </span>
      </p>

      <p className="md:flex items-center mt-8 md:mt-2">
        <i className="block md:inline material-icons text-lime-500 mr-3 text-3xl pt-2 mb-2 md:mb-0">
          sticky_note_2
        </i>{" "}
        <span className="text-xl text-lime-100">
          Book UI/UX teardown {"->"}{" "}
          <span className="block md:inline">
            <a
              className="txtlink underline text-lime-500"
              href="mailto:mike@m1k3.net?subject=👋 UI/UX audit request&body=Hey Mike, I'd love to have you audit ______tell_me_about_it_______"
            >
              <span>schedule now</span>
            </a>
          </span>
        </span>
      </p>
    </div>
  );
}

function Brand({ img, title, children }) {
  return (
    <div className="flex flex-col justify-center items-center py-6 md:py-8">
      <img src={img} width="60px" className="mb-4 rounded-3xl shadow" alt={title} />
      {title && (
        <p className="text-white font-bold text-xl md:mb-2 md:block">
          {title}
        </p>
      )}
      <p className="text-white text-center leading-snug px-4 md:px-8">
        {children}
      </p>
    </div>
  );
}

function Service({ icon = "chat", children }) {
  return (
    <div className="flex justify-center items-center p-8">
      <i className="material-icons text-white text-3xl">{icon}</i>
      <p className="text-white font-bold ml-3 text-lg">{children}</p>
    </div>
  );
}

// eslint-disable-next-line no-unused-vars
function _Header() {
  return (
    <div
      className="mx-auto px-12 md:px-24"
      style={{ maxWidth: "1000px" }}
    >
      <h2 className="text-5xl md:text-8xl font-bold leading-tight md:leading-tight mb-16 text-white text-center md:text-left">
        A product design{" "}
        <span className="last-line-row">
          <span className="last-line-element">studio.</span>
          <i />
        </span>
      </h2>

      <CTA />
    </div>
  );
}

function Footer() {
  return (
    <div className="mx-auto">
      <div className="font-medium text-lg md:text-2xl text-center flex items-center justify-center text-gray-600 py-12 md:py-24">
        &copy; 2003–2026 • M1K3, LLC
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    const elements = document.querySelectorAll(".last-line");
    const nameElement = "last-line-element";
    const nameRow = "last-line-row";
    const span = document.createElement("i");

    const wrapAll = (nodes, wrapper, elem) => {
      const parent = nodes[0].parentNode;
      const { previousSibling } = nodes[0];
      for (
        let i = 0;
        nodes.length - i;
        wrapper.firstChild === nodes[0] && (i += 1)
      ) {
        wrapper.appendChild(nodes[i]);
        wrapper.appendChild(span);
      }
      if (previousSibling) {
        parent.insertBefore(wrapper, previousSibling.nextSibling);
      } else {
        elem.appendChild(wrapper);
      }
      return wrapper;
    };

    const findLastRow = (elem) => {
      const content = elem.innerText.trim();
      const contentArr = content.split(" ");
      let contentFormatted = "";
      contentArr.forEach((item) => {
        contentFormatted += `<span>${item} </span>`;
      });
      const element = elem;
      element.innerHTML = contentFormatted;

      const childrenSpan = Array.from(elem.getElementsByTagName("span"));
      let top = 0;
      childrenSpan.forEach((item) => {
        const thisTop = item.offsetTop;
        if (thisTop === top) {
          item.classList.add(nameElement);
        } else {
          childrenSpan.forEach((el) => {
            el.classList.remove(nameElement);
          });
          top = thisTop;
          item.classList.add(nameElement);
        }
      });

      const wrapElements = element.querySelectorAll(`.${nameElement}`);
      const wrapper = document.createElement("span");
      wrapper.classList.add(nameRow);
      wrapAll(wrapElements, wrapper, elem);
    };

    const findLastRows = () => {
      elements.forEach((elem) => {
        findLastRow(elem);
      });
    };

    window.addEventListener("resize", () => {
      findLastRows();
    });
    findLastRows();
  }, []);

  return (
    <div
      className="text-white font-sans pt-24 md:pt-0"
      style={{
        backgroundSize: "50%",
        backgroundRepeat: "repeat-x",
        cursor: `url(${cursor}), default`,
      }}
    >
      <div className="fixed z-50 left-0 top-0 right-0">
        <HUD />
      </div>
      <Section>
      <Para>
      <div className="mb-8 uppercase font-bold bg-lime-500 text-sm text-black rounded-3xl px-3.5 py-2 inline-block">
            Hey, it's Mike!
          </div>
        </Para>

        <Title>
          Designer{" "}
          <span className="font-mono text-lime-500">&</span> coder that builds
          my ideas and helps you w/ yours.
        </Title>
        <Para>
          <div className="pt-6">I run a product studio that has an established, repeatable method for
          designing and building successful products. It's also an operating
          model with two sides: your products and my products. Both complement
          each other with shared learnings that feed into a continuous
          improvement cycle for the both of us.</div>
        </Para>

        <Para>
        <div className="mt-12 mb-8 uppercase font-bold bg-gray-500 text-sm text-white rounded-3xl px-3.5 py-2 inline-block">
          
            My products
          </div>
        </Para>

        <div className="flex flex-wrap -ml-2">
        <Block w="4x" row="1" pattern={img_blockT2}>
            <Brand img="https://media.licdn.com/dms/image/v2/D4E0BAQFm2fNmWMTqxg/company-logo_100_100/B4EZxIxAbRG0AQ-/0/1770747332651/agreehq_logo?e=1772668800&v=beta&t=tKzeCF6kc40-G9rmV28qh98iPuSKSO9Eg8LL8v4mRhs" title="Agree.com">
              <span className="text-gray-400 block">
Agentic revenue operating system.
              </span>
              <a href="https://agree.com" target="_blank" rel="noreferrer">
                <Badge color="green">
                  <i className="material-icons text-lg mr-2">launch</i> Launch
                </Badge>
              </a>
            </Brand>
          </Block>
          <Block w="4x" row="1" pattern={img_blockT3}>
            <Brand img="https://www.usegather.com/new-logo.png" title="Gather.money">
              <span className="text-gray-400 block">
                Collaborative finance tool for couples.
              </span>
              <Badge>
                <i className="material-icons text-lg mr-2">check_circle</i>{" "}
                Acquired
              </Badge>
            </Brand>
          </Block>
          <Block w="4x" row="1" pattern={img_blockT1}>
            <Brand img={img_cage} title="CageApp.com">
              <span className="text-gray-400 block">
                Design collaboration for creative teams.
              </span>
              <Badge>
                <i className="material-icons text-lg mr-2">check_circle</i>{" "}
                Acquired
              </Badge>
            </Brand>
          </Block>
          <Block w="4x" row="1" pattern={img_blockT3}>
            <Brand img={img_nvite} title="nvite.com">
              <span className="text-gray-400 block">
                Event ticketing w/ embedded payments.
              </span>
              <Badge>
                <i className="material-icons text-lg mr-2">check_circle</i>{" "}
                Acquired
              </Badge>
            </Brand>
          </Block>

        </div>
      </Section>

      <Section>
      <Para>
          <div className="mb-8 uppercase font-bold bg-lime-500 text-sm text-black rounded-3xl px-3.5 py-2 inline-block">
            My Craft
          </div>
        </Para>

        <Title>I bring a skillset that adapts for your team.</Title>
        <Para>
          <div className="mt-4">My experience spans the past two decades
          founding startups and partnering with clients. In doing so, I built a
          skillset that adapts to fill the role your team needs. My bread and
          butter is design systems and how they empower collaboration and/or
          unify fragmentation, but I'd love to hear about your project and how I
          can help.</div>
        </Para>

        <div className="flex flex-wrap mt-8 -ml-2">
          <Block w="3x" row="1" pattern={img_blockT4}>
            <Service icon="sports_esports">Product Strategy</Service>
          </Block>
          <Block w="3x" row="1" pattern={img_blockT3}>
            <Service icon="create">Product Design</Service>
          </Block>
          <Block w="3x" row="1" pattern={img_blockT1}>
            <Service icon="code">Front-end Development</Service>
          </Block>
          <Block w="3x" row="2">
            <Service icon="extension">Design Systems</Service>
          </Block>
          <Block w="3x" row="2">
            <Service icon="toggle_on">Interface Design</Service>
          </Block>
          <Block w="3x" row="2">
            <Service icon="auto_fix_high">Product Marketing</Service>
          </Block>
          <Block w="3x" row="3" pattern={img_blockB2}>
            <Service icon="smart_button">UI Components</Service>
          </Block>
          <Block w="3x" row="3" pattern={img_blockB3}>
            <Service icon="chat_bubble">User Research</Service>
          </Block>
          <Block w="3x" row="3" pattern={img_blockB1}>
            <Service icon="color_lens">Visual Design</Service>
          </Block>
        </div>
      </Section>

      <Section>
      <Para>
          <div className="mb-8 uppercase font-bold bg-lime-500 text-sm text-black rounded-3xl px-3.5 py-2 inline-block">
            My Experience 
          </div>
        </Para>
        <Title>
          I've worked with the most{" "}
          <span className="font-mono text-lime-500">&lt;3</span>'ed brands.
        </Title>
        <Para>
         <div className="mt-4">Based in Texas, partnering remotely with companies big and small – often joining internal Slacks and meetings so that I'm around to understand your business. I've worked in every environment imaginable: agency-life, self-employed, and in-house where I grassrooted design systems from scratch to help designers and engineers collaborate better, together.</div>
        </Para>

        <div className="block md:flex md:flex-wrap mt-8 -ml-2">
          <Block row="1" pattern={img_blockT1}>
            <Brand img={img_google}>
              Prototyped aspirational interactive patterns
            </Brand>
          </Block>
          <Block row="1" pattern={img_blockT2}>
            <Brand img={img_svmk}>
              Design system that unified all products
            </Brand>
          </Block>
          <Block row="1" pattern={img_blockT3}>
            <Brand img={img_nfl}>Design/coded a social media aggregator</Brand>
          </Block>
          <Block row="1" pattern={img_blockT4}>
            <Brand img={img_natgeo}>Design/coded Cat Week explorer hub</Brand>
          </Block>
          <Block row="2">
            <Brand img={img_quora}>
              Design systems, UI components, mentorship
            </Brand>
          </Block>
          <Block row="2">
            <Brand img={img_brex}>Helped launch their first SaaS product</Brand>
          </Block>
          <Block row="2">
            <Brand img={img_amazon}>Design systems, UI components</Brand>
          </Block>
          <Block row="2">
            <Brand img={img_apple}>Design/prototyped concept demos</Brand>
          </Block>
          <Block row="3" pattern={img_blockB1}>
            <Brand img={img_zillow}>
              Product design,
              <br />
              UI design
            </Brand>
          </Block>
          <Block row="3" pattern={img_blockB2}>
            <Brand img={img_eb}>Design/coded SXSW interactive collection</Brand>
          </Block>
          <Block row="3" pattern={img_blockB3}>
            <Brand img={img_samsung}>Design/coded samsung.com site</Brand>
          </Block>
          <Block row="3" pattern={img_blockB4}>
            <Brand img={img_twitch}>Design systems, UI components</Brand>
          </Block>
        </div>
      </Section>

      <Section>
    

<Para>
  <div className="mb-8 uppercase font-bold bg-lime-500 text-sm text-black rounded-3xl px-3.5 py-2 inline-block">
    My work
  </div>
</Para>
<Title>
I sweat the details that let teams move faster.
</Title>
<Para>
<div className="mt-4">From early concept to shipped interface, I focus on clarity, cohesion, and execution. The details aren’t decoration — they’re what make systems usable, scalable, and trusted by real teams.</div>
</Para>
<div className="flex flex-wrap mt-8 -ml-2">
  <Block color="none" w="3x">
    <img src={img_work0} alt="Gather project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img
      src={img_work2}
      alt="SurveyMonkey Design System project"
      className="rounded-3xl"
    />
  </Block>
  <Block color="none" w="3x">
    <img
      src={img_work3}
      alt="SurveyMonkey Components project"
      className="rounded-3xl"
    />
  </Block>
  <Block color="none" w="3x">
    <img
      src={img_work6}
      alt="Music player project"
      className="rounded-3xl"
    />
  </Block>
  <Block color="none" w="3x">
    <img src={img_workcard} alt="Nvite project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img src={img_card} alt="Map project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img src={img_work4} alt="Quora project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img
      src={img_work9}
      alt="Gather budgets project"
      className="rounded-3xl"
    />
  </Block>
  <Block color="none" w="3x">
    <img
      src={img_workenergy}
      alt="Energy project"
      className="rounded-3xl"
    />
  </Block>
  <Block color="none" w="3x">
    <img src={img_workmap} alt="Map project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img src={img_gatherchat} alt="Map project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img src={img_cage2} alt="Map project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img src={img_sync} alt="Map project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img src={img_flow} alt="Map project" className="rounded-3xl" />
  </Block>
  <Block color="none" w="3x">
    <img src={img_cmd} alt="Map project" className="rounded-3xl" />
  </Block>
</div>
      </Section>
      <Footer />
    </div>
  );
}

export default App;
